export default function controlAdminDirective() {
  return {
    template: require('./control-admin.html'),
    controller: 'ControlAdminController',
    controllerAs: 'controlAdminVM',
    bindToController: true,
    replace: true,
  };
}
